import React, { Component } from "react";
import { Provider } from "react-redux";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { ROOT, apiROOT } from "./config/config";
import NavBar from "./components/NavBar";
import ColumnOne from "./components/ColumOne";
import ColumnThree from "./components/ColumnThree";
import Home from "./pages/Home";
import Notification from "./pages/Notification";
import User from "./pages/User";
import UserFormEditor from "./editors/UserFormEditor";
import MainPost from "./pages/MainPost";
import ReportEditor from "./editors/ReportEditor";
import { ReactComponent as CloseSVG } from "./images/svg/close.svg";
import ArticleEditor from "./editors/ArticleEditor";
import Search from "./pages/Search";
import NoMatch from "./pages/NoMatch";
import AllPost from "./admin/post/AllPost";
import UserTable from "./admin/user/UserTable";
import ReportTable from "./admin/ReportTable";
import AllNewsLetter from "./admin/newsletter/AllNewsLetter";
import About from "./admin/About";
import Privacy from "./admin/Privacy";
import store from "./store";
import { FETCH_COLUMN_ONE } from "./actions/types";
import AllCategories from "./admin/category/AllCategories";
import Category from "./pages/Category";
import AllAudio from "./admin/audio/AllAudio";

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoggedIn: true
    };

    this.cleanEditor = this.cleanEditor.bind(this);
  }

  componentDidMount() {
    fetch(`${apiROOT}blog/getUserDetails`)
      .then(res => res.json())
      .then(data => {
        store.dispatch({
          type: FETCH_COLUMN_ONE,
          payload: data
        });

        this.setState({
          isLoggedIn: parseInt(data.user_id) > 0 ? true : false
        });
      });
  }

  cleanEditor(alertElem, type) {
    setTimeout(function () {
      let parentExec = "";
      let textArea = "";
      let editor = "";
      let elem = "";

      if (type === "Article") {
        elem = document.querySelector(".article-editor-wrapper");
        editor = document.getElementById("article_editor_frame");
        textArea = document.querySelector("#article_editor_ta");
        parentExec = document.querySelector(".editor-exec-btn-wrapper-article");
      } else if (type === "Comment") {
        elem = document.querySelector(".comment-editor-wrapper");
        editor = document.getElementById("comment_editor_frame");
        textArea = document.querySelector("#comment_editor_ta");
        parentExec = document.querySelector(".editor-exec-btn-wrapper-comment");
      } else if (type === "Newsletter") {
        elem = document.querySelector(".newsletter-editor-wrapper");
        editor = document.getElementById("newsletter_editor_frame");
        textArea = document.querySelector("#newsletter_editor_ta");
        parentExec = document.querySelector(
          ".editor-exec-btn-wrapper-newsletter"
        );
      } else if (type === "Audio") {
        elem = document.querySelector(".audio-editor-wrapper");
        editor = document.getElementById("audio_editor_frame");
        textArea = document.querySelector("#audio_editor_ta");
        parentExec = document.querySelector(".editor-exec-btn-wrapper-audio");
      }

      elem.classList.add("hide");
      elem.classList.remove("visible");

      alertElem.classList.remove("success-alert");
      alertElem.classList.remove("error-alert");
      alertElem.innerHTML = "";

      textArea.value = "";
      editor.contentWindow.document.body.innerHTML = "";

      let execBtns = parentExec.querySelectorAll(".green-fill").length;
      for (let i = 0; i < execBtns; i++) {
        parentExec.querySelectorAll(".green-fill")[i].classList.add("neutral");

        parentExec
          .querySelectorAll(".green-fill") // eslint-disable-next-line
        [i].classList.remove("green-fill");
      }
    }, 1000);
  }

  toggleArticleEditor = () => {
    if (!this.state.isLoggedIn) return;
    let alertElem = document.querySelector("#alert");
    let editor = document.getElementById("article_editor_frame");
    editor.contentWindow.document.designMode = "On";

    let elem = document.querySelector(".article-editor-wrapper");
    if (elem.classList.contains("hide")) {
      elem.classList.remove("hide");
      elem.classList.add("visible");
    } else {
      elem.classList.add("hide");
      elem.classList.remove("visible");
      this.cleanEditor(alertElem, "Article");
    }
  };

  toggleNewsletterEditor = () => {
    if (!this.state.isLoggedIn) return;
    let alertElem = document.querySelector("#alert40");
    let editor = document.getElementById("newsletter_editor_frame");
    editor.contentWindow.document.designMode = "On";

    let elem = document.querySelector(".newsletter-editor-wrapper");
    if (elem.classList.contains("hide")) {
      elem.classList.remove("hide");
      elem.classList.add("visible");
    } else {
      elem.classList.add("hide");
      elem.classList.remove("visible");
      this.cleanEditor(alertElem, "Newsletter");
    }
  };

  toggleAudioMessageEditor = () => {
    if (!this.state.isLoggedIn) return;
    let alertElem = document.querySelector("#alert-23");
    let editor = document.getElementById("audio_editor_frame");
    editor.contentWindow.document.designMode = "On";

    let elem = document.querySelector(".audio-editor-wrapper");
    if (elem.classList.contains("hide")) {
      elem.classList.remove("hide");
      elem.classList.add("visible");
    } else {
      elem.classList.add("hide");
      elem.classList.remove("visible");
      this.cleanEditor(alertElem, "Audio");
    }
  };

  render() {
    // basename="/intscribe/"
    return (
      <Provider store={store}>
        <Router basename="/">
          <NavBar root={ROOT} apiROOT={apiROOT}
            toggleArticleEditor={this.toggleArticleEditor} />

          <div className="App" id="intscribe">
            <div className="notification-alert"></div>
            <Switch>
              <Route
                exact
                path="/blog"
                render={props => (
                  <React.Fragment>
                    <ColumnOne />
                    <Home
                      {...props}
                      root={ROOT}
                      apiROOT={apiROOT}
                    />
                    <ColumnThree />
                  </React.Fragment>
                )}
              />

              <Route
                exact
                path="/category/:category"
                render={props => (
                  <React.Fragment>
                    <ColumnOne />
                    <Category
                      {...props}
                      root={ROOT}
                      apiROOT={apiROOT}
                    />
                    <ColumnThree />
                  </React.Fragment>
                )}
              />

              <Route
                exact
                path="/notification"
                render={props => (
                  <React.Fragment>
                    <ColumnOne />
                    <Notification
                      {...props}
                      root={ROOT}
                      apiROOT={apiROOT}
                      toggleArticleEditor={this.toggleArticleEditor}
                    />
                    <ColumnThree />
                  </React.Fragment>
                )}
              />

              <Route
                exact
                path="/search"
                render={props => (
                  <Search {...props} root={ROOT} apiROOT={apiROOT} />
                )}
              />

              <Route
                exact
                path="/user/editProfile"
                render={props => (
                  <UserFormEditor {...props} apiROOT={apiROOT} root={ROOT} />
                )}
              />

              <Route
                exact
                path="/user/:user"
                render={props => (
                  <User {...props} root={ROOT} apiROOT={apiROOT} />
                )}
              />

              <Route
                exact
                path="/user/:user/:suser"
                render={props => (
                  <User {...props} root={ROOT} apiROOT={apiROOT} />
                )}
              />

              <Route
                exact
                path="/post/:title"
                render={props => (
                  <React.Fragment>
                    <ColumnOne />
                    <MainPost
                      {...props}
                      root={ROOT}
                      apiROOT={apiROOT}
                      cleanEditor={this.cleanEditor}
                    />
                  </React.Fragment>
                )}
              />

              <Route
                exact
                path="/post/report/:reportTag/:postID"
                render={props => (
                  <ReportEditor {...props} apiROOT={apiROOT} root={ROOT} />
                )}
              />

              <Route
                exact
                path="/post/report/:reportTag/:postID/:commentID"
                render={props => (
                  <ReportEditor {...props} apiROOT={apiROOT} root={ROOT} />
                )}
              />

              <Route
                path="/post/report/:reportTag/:postID/:commentID/:subcommentID"
                render={props => (
                  <ReportEditor {...props} apiROOT={apiROOT} root={ROOT} />
                )}
              />

              <Route
                exact
                path="/admin"
                render={props => (
                  <AllPost {...props} apiROOT={apiROOT} root={ROOT} />
                )}
              />

              <Route
                exact
                path="/admin/user"
                render={props => (
                  <UserTable {...props} apiROOT={apiROOT} root={ROOT} />
                )}
              />
              <Route
                exact
                path="/admin/newsletter"
                render={props => (
                  <AllNewsLetter {...props}
                    toggleNewsletterEditor={this.toggleNewsletterEditor} apiROOT={apiROOT} root={ROOT} />
                )}
              />
              <Route
                exact
                path="/admin/audio"
                render={props => (
                  <AllAudio {...props} 
                    toggleAudioMessageEditor={this.toggleAudioMessageEditor} apiROOT={apiROOT} root={ROOT} />
                )}
              />
              <Route
                exact
                path="/admin/category"
                render={props => (
                  <AllCategories {...props} apiROOT={apiROOT} root={ROOT} />
                )}
              />

              <Route
                exact
                path="/admin/report"
                render={props => (
                  <ReportTable {...props} apiROOT={apiROOT} root={ROOT} />
                )}
              />

              <Route
                exact
                path="/admin/editor/about"
                render={props => (
                  <About {...props} apiROOT={apiROOT} root={ROOT} />
                )}
              />

              <Route
                exact
                path="/admin/editor/privacy"
                render={props => (
                  <Privacy {...props} apiROOT={apiROOT} root={ROOT} />
                )}
              />

              <Route component={NoMatch} />
            </Switch>

            <div className="article-editor-wrapper hide">
              <span
                className="article-editor-wrapper-close"
                onClick={this.toggleArticleEditor}
              >
                <CloseSVG /> Close
              </span>

              <ArticleEditor
                apiROOT={apiROOT}
                root={ROOT}
                post_title=""
                post_tags=""
                setter="insert"
                cleanEditor={this.cleanEditor}
              />
            </div>
          </div>
        </Router>
      </Provider>
    );
  }
}

export default App;
